<div class="word-list-container" [innerHTML]="htmlFormattedText"></div>
